<template>
	<el-container>
		<el-header>
			<!-- <img style="margin-top: 12px;max-width: 40px; float: left;" @click="toback()"
				:src='"/img/webimg/back.png"' alt=""> -->
				<el-button style="margin-top: 4px;font-size: 28px; float: left;color:#000000;" @click="toback()" icon="el-icon-arrow-left" type="text"></el-button>
			<span class="header_h2">套餐选择 </span>
		</el-header>
		<div>
			<el-table :show-header="headshow" @row-click="clickTable" class="dtrowselcolor" size="mini" ref="singleTable" highlight-current-row
				@current-change="SelGroup" :data="grouplist" @expand-change="expandChange">
				<el-table-column type="expand" width="20">
					<template slot-scope="props">
						<el-table border :data="props.row.groupitemlist" max-height='400px' style="width:100%">
							
							<el-table-column prop="SaleModuleName" label="项目名称" width="120">
							</el-table-column>
							<el-table-column prop="FNote" label="临床意义" width="230">
							</el-table-column>
						</el-table>
					</template>
				</el-table-column>
				<el-table-column prop="GroupName" label="111">
					<template slot-scope="scope">
						<el-row style="margin-top: 2px;margin-bottom: 2px;">
							<el-col :span="18">
								<p style="font-size: 20px;">{{scope.row.GroupName}}</p>
								<p class="myrowp" style="font-size: 10px;">
									{{GetGroupDesc(scope.row)}}
								</p>
							</el-col>
						</el-row>

					</template>
				</el-table-column>
			</el-table>
		</div>
		<div>
			<el-button style="width: 90%;font-size: 20px;" type="primary" @click="btnSaveGroup()">下一步</el-button>
		</div>
	</el-container>
</template>

<script>
	import ordergroup from '../../apifunction/OrderGroup.js'
	import ordercus from '../../apifunction/OrderCus.js'
	import groupitem from '../../apifunction/GroupItem.js'
	export default {
		created() {
			this.cusent = JSON.parse(this.$route.query.ent);
			// alert(JSON.stringify(this.cusent ))
			this.InitGroup();
		},
		data() {
			return {
				cusent: null,
				ordergroupent: null,
				grouplist: [],
				headshow:false
			}
		},
		methods: {
			toback()
			{
				var data = {
					path: '/BookForOrderCus',
					query: {
						ent: JSON.stringify(this.cusent)
					}
				}
				this.$router.push(data)
			
			},
			clickTable(row) {
				this.$refs.singleTable.toggleRowExpansion(row)
				this.$refs.singleTable.setCurrentRow(row)
			},
			expandChange(row, expandedRows) {
				this.grouplist.forEach((temp, index) => {
					// 找到当前点击的行，把动态获取到的数据赋值进去
					if (temp.GroupID === row.GroupID) {
						this.GetGroupItems(row, index);

						return;
					}
				});

			},
			GetGroupItems: function(groupEnt, index) {

				if (groupEnt.groupitemlist.length < 1) {
					groupitem.GetGroupItemWithFNote(this.cusent.corpid, groupEnt.OrderID, groupEnt.GroupID)
						.then(res => {
							let ent = JSON.parse(JSON.stringify(res.data));
							if (ent.Flag == 'success') {
								if (ent.Data == 'null')
									return;
								this.grouplist[index].groupitemlist = JSON.parse(ent.Data);
							}
						})
				}

			},
			InitGroup() {
				ordergroup.GetOrderGroupData(this.cusent.orderid)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							if (ent.Data != 'null') {

								let grplist = JSON.parse(ent.Data);

								let age = this.CommonFun.BirthdayToAge(this.cusent.cusbirthday);

								for (let i = 0; i < grplist.length; i++) {
									if (grplist[i].Sex != '3' && grplist[i].Sex != this.cusent.cussex) {
										continue;
									}

									if (grplist[i].MinAge > age || grplist[i].MaxAge < age) {
										continue;
									}
									if (grplist[i].Marry != '3' && grplist[i].Marry != this.cusent.cusmarry) {
										continue;
									}
									grplist[i].groupitemlist = []
									this.grouplist.push(grplist[i]);
									// if(grplist[i].GroupID==this.cusent.groupid)
									// {
									// 	alert(1)
									// 		this.ordergroupent =grplist[i];
									// 	this.clickTable(grplist[i])}
								}
								// if (this.grouplist.length == 1) {
								// 	this.ordergroupent = this.grouplist[0];
								// 	// this.btnSaveGroup();
								// }
								this.$nextTick(() => {
									if (this.grouplist.length < 1)
										return;
									this.grouplist.forEach((temp, index) => {
										// 找到当前点击的行，把动态获取到的数据赋值进去
										if (temp.GroupID === this.cusent.groupid) {

											this.ordergroupent = temp;
											this.clickTable(temp)
											return;
										}
									});
								})

							}
						} else
							this.$message.info(ent.Msg);
					});
			},
			GetGroupDesc(ent) {
				let s = '';
				s += '适用性别:';
				s += this.$enums.GetEnumNameByValue(this.$enums.AdaptSex, ent.Sex) + ' | ';
				s += '年龄:' + ent.MinAge + '-' + ent.MaxAge + ' | ';
				s += '婚姻:'
				s += this.$enums.GetEnumNameByValue(this.$enums.AdaptMarry, ent.Marry);
				return s;
			},
			SelGroup(item) {
				this.ordergroupent = item;
			},
			btnSaveGroup() {
				if (this.ordergroupent == null) {
					this.$message.info('请单击选择体检套餐！');
					return;
				}
				ordercus.UpdateCusGroupID(this.cusent.id, this.ordergroupent.GroupID)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							var data = {
								path: '/BookGroupAddSel',
								query: {
									ent: JSON.stringify(this.cusent),
									grpent: JSON.stringify(this.ordergroupent)
								}
							};
							this.$router.push(data)
						} else
							this.$message.info(ent.Msg);
					});
			}
		}
	}
</script>

<style>
	/* .el-table__body tr.current-row>td {
		background-color: #e6ae93 !important;
*/
	/* color: #f19944; */
	/* 设置文字颜色，可以选择不设置 */

	/* } */
</style>
